package modysy

import modysy.model._
import modysy.simulation.pp.{PopulationProtocol, SuccessConditions}
import modysy.simulation.pp.SuccessConditions.LevelResult.LevelResult
import modysy.tools.{Dialog, Tool}

import scala.collection.mutable.ListBuffer

/**
  * Holds all the information that is necessary to run a level.
  *
  * An outer field is the whole space provided for the game level. An inner field is the area surrounded by
  * the borders, inside of which the agents can move.
  */
/* TODO still missing: the concept of inner field (the inner area surrounded by borders, where objects can be placed).
    Other code will require something like Level.inField(shape: Geometry). Width and height would also need some
    renaming.
 */
abstract class Level {

  /** The population protocol used in this level. */
  val protocol: PopulationProtocol

  /** The current result of the level. */
  def result: LevelResult
  val onTimeUp: LevelResult = SuccessConditions.LevelResult.lose

  /** The width of the outer field. */
  val width: Int

  /** The height of the outer field. */
  val height: Int

  /**
    * The time (in seconds) the player has to complete the level
    */
  val time: Int

  /** The inner field. */
  val innerField: InnerField

  /** Tools available for the user */
  def availableTools(controller: GameController): List[Tool]

  /**
    * The list buffer containing all the objects present on the level, except for the borders of the inner field.
    * After the creation of a Level object, this buffer
    * contains the initial objects that are in the level design. The user of the Level object can append and delete
    * objects from this buffer. However be careful with storing references pointing to specific objects in this
    * buffer, as they will not point to objects present in the level after the resetObjects call.
    */
  var objects: ListBuffer[GameObject]

  var portals: Seq[(Portal, Portal)]

  /** Restore the initial objects that are specified in the level design. */
  def resetObjects(): Unit

  /**
    * Display level specific messages to inform the player of something.
    */
  def displayMessages(): Unit

  var dialogs: ListBuffer[Dialog]
  val nudge_uses: Int = 100
  val box_uses: Int = 100
  val coin: Boolean = false
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/Level.scala